import { render, staticRenderFns } from "./redpackage-record-get.vue?vue&type=template&id=5f02576d&scoped=true&"
import script from "./redpackage-record-get.vue?vue&type=script&lang=js&"
export * from "./redpackage-record-get.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f02576d",
  null
  
)

export default component.exports